"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
function convertObjectToIParametersDictionary(source) {
    if (source === undefined || source === null) {
        throw new Error('Invalid patameters');
    }
    var result = {};
    Object.entries(source)
        .forEach(function (_a) {
        var _b = __read(_a, 2), objectKey = _b[0], objectValue = _b[1];
        var convertedValue;
        if (objectValue === undefined) {
            return;
        }
        else if (objectValue instanceof Date) {
            convertedValue = convertDateToParamAsIsoDate(objectValue);
        }
        else if (objectValue !== null) {
            convertedValue = objectValue.toString();
        }
        result[objectKey] = convertedValue;
    });
    return result;
}
exports.convertObjectToIParametersDictionary = convertObjectToIParametersDictionary;
function convertDateToParamAsIsoDate(dateTime) {
    return dateTime.toISOString().replace(/\..*/gi, '');
    var pad = '0';
    var year = padLeft(dateTime.getFullYear().toString(), pad, 4);
    // ! нумерация месяцев начинается с нуля
    var month = padLeft((dateTime.getMonth() + 1).toString(), pad, 2);
    var date = padLeft(dateTime.getDate().toString(), pad, 2);
    var hours = padLeft(dateTime.getHours().toString(), pad, 2);
    var minutes = padLeft(dateTime.getMinutes().toString(), pad, 2);
    var seconds = padLeft(dateTime.getSeconds().toString(), pad, 2);
    //const ms = padLeft(dateTime.getMilliseconds().toString(), pad, 3);
    //return `${year}-${month}-${date}T${hours}:${minutes}:${seconds}.${ms}`;
    return year + "-" + month + "-" + date + "T" + hours + ":" + minutes + ":" + seconds;
}
exports.convertDateToParamAsIsoDate = convertDateToParamAsIsoDate;
function padLeft(value, pad, maxLength) {
    if (value.length >= maxLength || maxLength <= 0 || pad.length <= 0) {
        return value;
    }
    while (value.length < maxLength) {
        value = pad + value;
    }
    return value;
}
function jsonReplacer(key, value) {
    // value - уже строка
    var sourceValue = this[key];
    //console.log(`key: ${key}\nthis: ${JSON.stringify(this)}\nvalue: ${value}\nsourceValue: ${sourceValue}`)
    if (sourceValue === null || sourceValue === undefined) {
        return null;
    }
    if (sourceValue instanceof Date) {
        return convertDateToParamAsIsoDate(sourceValue);
    }
    return value;
}
exports.jsonReplacer = jsonReplacer;
//# sourceMappingURL=convert.js.map